import React from "react";
import "./Simulationfootercdmqb.css";
// All classNames are suffixed with "CDMQB" so they never collide with the
// default skin's CSS if that stylesheet happens to be loaded too.

export default function SimulationFooterCDMQB(props) {
  return (
    <div className="simulationFooterWrapperCDMQB">
      <div className="simulationFooterButtonsWrapperCDMQB">
        <span className="simulationFooterEndBlock">
          <div className="simulationFooterEndIcon"></div>
          <button
            className="simulationFooterExitCaseButtonCDMQB"
            onClick={props.displayExitCasePrompt}
          >
            <span className="simulationUnderline">P</span>ause Case
          </button>
        </span>
        {false && (
          <button
            className="simulationBodyLabPanelsButtonCDMQB"
            onClick={props.displayLabPanels}
          >
            LAB PANELS
          </button>
        )}
      </div>
      <div className="simulationFooterContainerCDMQB">
        <span className="simulationFooterNextBlock">
          {/* goToNextPart shows the End of Part confirmation, or submits
              right away when "Confirm before Next" is off in Settings. */}
          <button
            className="simulationFooterSubmitButtonCDMQB"
            onClick={props.goToNextPart || props.updateSubmitStep}
          >
            <span className="simulationUnderline">N</span>ext
          </button>
          <div className="simulationFooterNextIcon"></div>
        </span>
      </div>
    </div>
  );
}
